/*
 * Lavderma storefront interactions. No dependencies.
 * Layers (menu, search, cart, filters, compare, lightbox), mega menu, predictive search, AJAX cart,
 * product page (gallery, section nav, buy box, sticky bar), listing (AJAX filters, view, compare).
 * Motion follows NN/g and Material 3 guidance: transform and opacity only, enter slower than exit,
 * nothing above 400 ms, all of it switched off under prefers-reduced-motion.
 */
(function () {
  'use strict';
  if (window.__lav) return;
  window.__lav = true;

  var d = document;
  var html = d.documentElement;
  html.classList.add('lav-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktopMq = window.matchMedia('(min-width: 990px)');
  var tabletMq = window.matchMedia('(min-width: 750px)');

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function dur(ms) { return reduceMotion.matches ? 0 : ms; }
  function behaviour() { return reduceMotion.matches ? 'auto' : 'smooth'; }
  function money(p) {
    var s = (Math.round(p) / 100).toFixed(2).split('.');
    return '£' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function parseHTML(t) { return new DOMParser().parseFromString(t, 'text/html'); }

  var header = $('[data-lav-header]');
  var headerGroup = header && (header.closest('#header-group') || header.closest('.shopify-section-group-header-group') || header.parentElement);
  var ROOT = (header && header.getAttribute('data-root')) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var CART_URL = (header && header.getAttribute('data-cart-url')) || '/cart';
  function onCartPage() { return location.pathname.replace(/\/$/, '') === CART_URL.replace(/\/$/, ''); }

  /* ---------- Portals: layers live directly under <body> ---------- */
  $$('[data-lav-portal]').forEach(function (el) { d.body.appendChild(el); });

  /* ---------- Screen reader announcements (WCAG 4.1.3) and toast ---------- */
  var live = d.createElement('div');
  live.className = 'lav-visually-hidden';
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('role', 'status');
  d.body.appendChild(live);
  function announce(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }

  var toastEl = $('[data-lav-toast]');
  var toastTimer;
  function toast(msg, isError) {
    if (!toastEl) { announce(msg); return; }
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.setAttribute('role', isError ? 'alert' : 'status');
    toastEl.hidden = false;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-open');
      setTimeout(function () { if (!toastEl.classList.contains('is-open')) toastEl.hidden = true; }, dur(240));
    }, isError ? 6000 : 4000);
  }

  /* ---------- Header height for sticky offsets ---------- */
  var nav = header && $('.lav-nav', header);
  function measureHeader() { if (nav) html.style.setProperty('--lav-header-h', nav.offsetHeight + 'px'); }
  measureHeader();
  window.addEventListener('resize', measureHeader);

  /* ---------- Layer manager: modal dialogs with focus trap, Esc, scroll lock (WAI-ARIA APG) ---------- */
  var backdrop = $('[data-lav-backdrop]');
  var active = null;
  var lastFocus = null;
  var hideTimer;

  function focusables(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetWidth || n.offsetHeight || n.getClientRects().length; });
  }
  function setExpanded(id, on) {
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function openLayer(id, opener) {
    var el = d.getElementById(id);
    if (!el) return false;
    closeMega(true);
    if (active && active !== el) closeLayer(true, true);
    if (active === el) return true;
    if (!lastFocus || !active) lastFocus = opener || d.activeElement;
    clearTimeout(hideTimer);
    el.hidden = false;
    if (backdrop) backdrop.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    html.setAttribute('scroll-lock', '');
    setExpanded(id, true);
    active = el;
    setHeaderHidden(false);
    var target = $('[data-lav-search-input]', el) || $('[data-lav-autofocus]', el) || $('[data-lav-close]', el) || focusables(el)[0];
    setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, dur(60));
    el.dispatchEvent(new CustomEvent('lav:open'));
    return true;
  }
  function closeLayer(instant, keepFocus) {
    if (!active) return;
    var el = active;
    active = null;
    el.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    setExpanded(el.id, false);
    html.removeAttribute('scroll-lock');
    var finish = function () {
      if (!el.classList.contains('is-open')) el.hidden = true;
      if (!active && backdrop) backdrop.hidden = true;
    };
    if (instant) finish(); else hideTimer = setTimeout(finish, dur(260));
    if (!keepFocus && lastFocus && lastFocus.focus && d.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    if (!keepFocus) lastFocus = null;
    el.dispatchEvent(new CustomEvent('lav:close'));
  }
  window.LavLayer = { open: openLayer, close: closeLayer };

  d.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lav-open]');
    if (opener) {
      var id = opener.getAttribute('data-lav-open');
      if (id === 'LavCart' && onCartPage()) return;
      if (d.getElementById(id)) {
        e.preventDefault();
        if (active && active.id === id) closeLayer(); else openLayer(id, opener);
      }
      return;
    }
    if (e.target.closest('[data-lav-close]') && active) { e.preventDefault(); closeLayer(); return; }
    if (backdrop && e.target === backdrop) closeLayer();
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (lbZoomed && active && active.id === 'LavLightbox') { unzoom(); return; }
      if (active) { e.preventDefault(); closeLayer(); return; }
      if (megaOpen) { closeMega(); if (megaBtn) megaBtn.focus(); }
      return;
    }
    if (e.key === 'Tab' && active) {
      var f = focusables(active);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || !active.contains(d.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (d.activeElement === last || !active.contains(d.activeElement))) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.key === '/' && !active && !e.metaKey && !e.ctrlKey && !/^(input|textarea|select)$/i.test((d.activeElement || {}).tagName || '') && !(d.activeElement && d.activeElement.isContentEditable)) {
      if (d.getElementById('LavSearch')) { e.preventDefault(); openLayer('LavSearch'); }
    }
  });

  desktopMq.addEventListener('change', function () {
    measureHeader();
    if (active && active.id === 'LavMenu' && desktopMq.matches) closeLayer(true);
  });
  tabletMq.addEventListener('change', function () { if (active && active.id === 'LavFilters' && tabletMq.matches) closeLayer(true); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && active) closeLayer(true, true); });

  /* ---------- Header: shadow when stuck; on mobile hide on scroll down, reveal on scroll up (NN/g) ---------- */
  var tradebar = header && $('.lav-tradebar', header);
  if (header && tradebar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { header.classList.toggle('is-stuck', !entries[0].isIntersecting); }, { threshold: 0 }).observe(tradebar);
  }
  var headerHidden = false;
  function setHeaderHidden(v) {
    if (!headerGroup || headerHidden === v) return;
    headerHidden = v;
    headerGroup.classList.toggle('lav-hdr-hidden', v);
  }
  var pageWrapper = $('.page-wrapper');
  function scrollTop() { return Math.max(window.pageYOffset || 0, d.documentElement.scrollTop || 0, pageWrapper ? pageWrapper.scrollTop : 0); }
  var lastY = scrollTop();
  var scrollTicking = false;
  var scrollHandlers = [];
  function onScrollFrame() {
    scrollTicking = false;
    var y = scrollTop();
    if (!desktopMq.matches && header) {
      var focusInHeader = !!header.querySelector(':focus-visible');
      if (y < 120 || active || megaOpen || focusInHeader) setHeaderHidden(false);
      else if (y > lastY + 6) setHeaderHidden(true);
      else if (y < lastY - 6) setHeaderHidden(false);
    } else {
      setHeaderHidden(false);
    }
    lastY = y;
    scrollHandlers.forEach(function (fn) { fn(y); });
  }
  d.addEventListener('scroll', function () {
    if (!scrollTicking) { scrollTicking = true; requestAnimationFrame(onScrollFrame); }
  }, { passive: true, capture: true });

  /* ---------- Mega menu: disclosure pattern; click always works, hover opens after 300 ms and closes 500 ms after leaving (Baymard, NN/g) ---------- */
  var mega = $('[data-lav-mega]');
  var megaPanel = d.getElementById('LavMega');
  var megaBtn = mega && $('[data-lav-mega-btn]', mega);
  var megaOpen = false;
  var megaOpenT, megaCloseT;
  function showMega() {
    if (!megaPanel) return;
    clearTimeout(megaCloseT);
    if (megaOpen) return;
    megaOpen = true;
    megaPanel.hidden = false;
    void megaPanel.offsetWidth;
    megaPanel.classList.add('is-open');
    mega.classList.add('is-open');
    megaBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMega(now) {
    if (!megaPanel) return;
    clearTimeout(megaOpenT);
    if (!megaOpen) return;
    megaOpen = false;
    megaPanel.classList.remove('is-open');
    mega.classList.remove('is-open');
    megaBtn.setAttribute('aria-expanded', 'false');
    clearTimeout(megaCloseT);
    megaCloseT = setTimeout(function () { if (!megaOpen) megaPanel.hidden = true; }, now ? 0 : dur(200));
  }
  if (mega && megaPanel && megaBtn) {
    var megaLink = $('[data-lav-mega-link]', mega);
    megaBtn.addEventListener('click', function (e) { e.preventDefault(); if (megaOpen) closeMega(); else showMega(); });
    [mega, megaPanel].forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (!hoverMq.matches) return;
        clearTimeout(megaCloseT);
        clearTimeout(megaOpenT);
        if (!megaOpen) megaOpenT = setTimeout(showMega, 300);
      });
      el.addEventListener('mouseleave', function () {
        if (!hoverMq.matches) return;
        clearTimeout(megaOpenT);
        if (megaOpen) megaCloseT = setTimeout(function () { closeMega(); }, 500);
      });
    });
    if (megaLink) megaLink.addEventListener('click', function (e) { if (!hoverMq.matches && !megaOpen) { e.preventDefault(); showMega(); } });
    d.addEventListener('click', function (e) { if (megaOpen && !mega.contains(e.target) && !megaPanel.contains(e.target)) closeMega(); });
    megaPanel.addEventListener('focusout', function (e) {
      if (megaOpen && e.relatedTarget && !megaPanel.contains(e.relatedTarget) && !mega.contains(e.relatedTarget)) closeMega();
    });
  }

  /* ---------- Accordions: smooth <details> (250 ms open, 200 ms close) and "Expand all" ---------- */
  function animateDetails(det, open) {
    det.__lavTarget = open;
    var content = det.querySelector(':scope > summary + *');
    if (!content || reduceMotion.matches || !Element.prototype.animate) { det.open = open; return; }
    if (det.__lavAnim) { det.__lavAnim.onfinish = null; det.__lavAnim.cancel(); content.style.overflow = ''; }
    if (open) {
      det.open = true;
      var h = content.scrollHeight;
      content.style.overflow = 'hidden';
      det.__lavAnim = content.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 250, easing: 'cubic-bezier(.05, .7, .1, 1)' });
    } else {
      var h2 = content.scrollHeight;
      content.style.overflow = 'hidden';
      det.__lavAnim = content.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'cubic-bezier(.3, 0, .8, .15)' });
    }
    det.__lavAnim.onfinish = function () { if (!open) det.open = false; content.style.overflow = ''; det.__lavAnim = null; };
  }
  d.addEventListener('click', function (e) {
    var summary = e.target.closest('details[data-lav-anim] > summary');
    if (summary) {
      e.preventDefault();
      var det = summary.parentElement;
      animateDetails(det, !isOpen(det));
      syncExpandAll(det.closest('[data-lav-acc-group]'));
      return;
    }
    var ex = e.target.closest('[data-lav-expand]');
    if (ex) {
      var group = ex.closest('[data-lav-acc-group]');
      var all = $$('details', group);
      var openAll = !all.every(isOpen);
      all.forEach(function (x) { if (isOpen(x) !== openAll) animateDetails(x, openAll); });
      syncExpandAll(group);
    }
  });
  function isOpen(det) { return det.__lavTarget !== undefined ? det.__lavTarget : det.open; }
  function syncExpandAll(group) {
    if (!group) return;
    var ex = $('[data-lav-expand]', group);
    if (!ex) return;
    var allOpen = $$('details', group).every(isOpen);
    ex.textContent = allOpen ? 'Collapse all' : 'Expand all';
    ex.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
  }

  /* ---------- Product page: in-page section nav with scroll spy (replaces tabs, Baymard) ---------- */
  $$('[data-lav-toc]').forEach(function (toc) {
    var links = $$('a[href^="#"]', toc);
    var ink = $('.lav-toc__ink', toc);
    var secs = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var current = null;
    function mark(i) {
      if (i === current) return;
      current = i;
      links.forEach(function (a, k) { a.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var a = links[i];
      if (ink && a) { ink.style.width = a.offsetWidth + 'px'; ink.style.transform = 'translateX(' + a.offsetLeft + 'px)'; }
    }
    function spy() {
      if (!toc.offsetParent) return;
      var line = (nav ? nav.offsetHeight : 0) + toc.offsetHeight + 64;
      var idx = 0;
      secs.forEach(function (s, k) { if (s && s.getBoundingClientRect().top - line <= 0) idx = k; });
      mark(idx);
    }
    links.forEach(function (a, k) {
      a.addEventListener('click', function (e) {
        var t = secs[k];
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: behaviour(), block: 'start' });
        mark(k);
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      });
    });
    scrollHandlers.push(spy);
    requestAnimationFrame(function () { current = null; spy(); if (current === null) mark(0); toc.classList.add('is-ready'); });
    window.addEventListener('resize', function () { var c = current; current = null; mark(c || 0); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { var c = current; current = null; mark(c || 0); });
  });

  d.addEventListener('click', function (e) {
    var j = e.target.closest('[data-lav-jump]');
    if (!j) return;
    var target = d.getElementById(j.getAttribute('data-lav-jump'));
    var acc = d.getElementById(j.getAttribute('data-lav-acc') || '');
    if (acc && acc.offsetParent) target = acc;
    else if (target && !target.offsetParent && acc) target = acc;
    if (!target) return;
    e.preventDefault();
    if (target.tagName === 'DETAILS' && !target.open) animateDetails(target, true);
    target.scrollIntoView({ behavior: behaviour(), block: 'start' });
  });

  /* ---------- Quantity steppers, copy, set quantity, print ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.lav-qty [data-step]');
    if (b) {
      var i = b.parentElement.querySelector('input');
      if (!i) return;
      e.preventDefault();
      var step = parseInt(i.step, 10) || 1;
      var min = parseInt(i.min, 10);
      if (isNaN(min)) min = 1;
      var max = i.max ? parseInt(i.max, 10) : Infinity;
      var v = (parseInt(i.value, 10) || min) + parseInt(b.getAttribute('data-step'), 10) * step;
      i.value = Math.max(min, Math.min(max, v));
      i.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    var c = e.target.closest('[data-lav-copy]');
    if (c) {
      e.preventDefault();
      var text = c.getAttribute('data-lav-copy');
      var label = c.querySelector('[data-lav-copy-label]');
      var done = function (ok) {
        c.classList.add('is-copied');
        announce(ok ? 'Copied to clipboard' : 'Copy failed');
        if (label) { var old = label.getAttribute('data-default') || label.textContent; label.setAttribute('data-default', old); label.textContent = ok ? 'Copied' : 'Copy failed'; setTimeout(function () { label.textContent = old; c.classList.remove('is-copied'); }, 1600); }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); }); else done(false);
      return;
    }
    var s = e.target.closest('[data-lav-setqty]');
    if (s) {
      e.preventDefault();
      var main = $('[data-lav-qty-main]');
      if (main) { main.value = s.getAttribute('data-lav-setqty'); main.dispatchEvent(new Event('input', { bubbles: true })); main.focus(); }
      return;
    }
    if (e.target.closest('[data-lav-print]')) { e.preventDefault(); window.print(); }
  });

  /* ---------- AJAX cart (Cart API + Section Rendering API, one request per change) ---------- */
  var cartSheet = d.getElementById('LavCart');
  var cartBox = cartSheet && $('[data-lav-cart-drawer]', cartSheet);
  function toJSON(r) {
    return r.json().then(function (j) {
      if (!r.ok) { var err = new Error(j.description || j.message || 'Something went wrong. Please try again.'); err.data = j; throw err; }
      return j;
    });
  }
  function updateCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    $$('[data-lav-count]').forEach(function (c) {
      var was = c.getAttribute('data-count');
      c.textContent = n;
      c.setAttribute('data-count', n);
      if (String(was) !== String(n) && n > 0 && !reduceMotion.matches) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    });
    $$('[data-lav-count-text]').forEach(function (c) { c.textContent = n; });
  }
  function cartLines(root) {
    var map = {};
    if (!root) return map;
    $$('[data-pid]', root).forEach(function (li) { var id = li.getAttribute('data-pid'); map[id] = (map[id] || 0) + (parseInt(li.getAttribute('data-q'), 10) || 0); });
    return map;
  }
  function flagCards(root) {
    var map = cartLines(root);
    $$('[data-lav-pid]').forEach(function (card) {
      var n = map[card.getAttribute('data-lav-pid')] || 0;
      var badge = $('[data-lav-incart-badge]', card);
      card.classList.toggle('is-incart', n > 0);
      if (badge) { badge.hidden = n === 0; var t = $('[data-lav-incart-text]', badge); if (t) t.textContent = 'In your cart (' + n + ')'; }
    });
  }
  var Cart = {
    sections: function () {
      var s = ['lav-cart-drawer'];
      var page = $('[data-lav-cart-section]');
      if (page) s.push(page.getAttribute('data-lav-cart-section'));
      return s;
    },
    apply: function (sections) {
      if (!sections) return;
      var focusKey = null, focusStep = null;
      var ae = d.activeElement;
      if (ae && ae.getAttribute && ae.getAttribute('data-lav-line')) { focusKey = ae.getAttribute('data-lav-line'); focusStep = ae.getAttribute('data-lav-step') || ae.getAttribute('data-qty'); }
      var dr = sections['lav-cart-drawer'];
      if (dr && cartBox) {
        var root = parseHTML(dr).querySelector('[data-lav-cart-root]');
        if (root) {
          cartBox.innerHTML = '';
          cartBox.appendChild(root);
          updateCount(parseInt(root.getAttribute('data-count'), 10));
          flagCards(root);
          d.dispatchEvent(new CustomEvent('lav:cart', { detail: { root: root } }));
        }
      }
      var page = $('[data-lav-cart-section]');
      if (page) {
        var id = page.getAttribute('data-lav-cart-section');
        if (sections[id]) {
          var nr = parseHTML(sections[id]).querySelector('[data-lav-cart-section]');
          if (nr) page.replaceWith(nr);
        }
      }
      if (focusKey) {
        var again = $$('[data-lav-line="' + focusKey.replace(/"/g, '') + '"]').filter(function (n) { return (n.getAttribute('data-lav-step') || n.getAttribute('data-qty')) === focusStep && n.offsetParent; })[0];
        if (again) again.focus({ preventScroll: true });
        else if (active) { var c = $('[data-lav-close]', active); if (c) c.focus({ preventScroll: true }); }
      }
      if (window.LavDispatch) window.LavDispatch.render();
    },
    add: function (formData) {
      formData.append('sections', Cart.sections().join(','));
      formData.append('sections_url', location.pathname);
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData }).then(toJSON);
    },
    addItems: function (items) {
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: Cart.sections(), sections_url: location.pathname }) }).then(toJSON);
    },
    change: function (key, quantity) {
      var body = { quantity: quantity, sections: Cart.sections(), sections_url: location.pathname };
      if (/^\d+$/.test(String(key))) body.line = parseInt(key, 10); else body.id = key;
      return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(toJSON);
    },
    update: function (data) {
      return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(toJSON);
    },
    refresh: function () {
      return fetch(location.pathname + '?sections=' + Cart.sections().join(','), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(Cart.apply).catch(function () {});
    },
    open: function () { return openLayer('LavCart'); },
    toast: toast,
    announce: announce
  };
  window.LavCart = Cart;
  if (cartBox) flagCards($('[data-lav-cart-root]', cartBox));

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]') || !cartBox) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', f);
    if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(f);
    Cart.add(fd).then(function (res) {
      Cart.apply(res.sections);
      if (btn) btn.classList.remove('is-loading');
      var title = res.product_title || (res.items && res.items[0] && res.items[0].product_title) || 'Item';
      var qty = res.quantity || fd.get('quantity') || 1;
      if (onCartPage()) toast(title + ' added to your cart');
      else { openLayer('LavCart', btn); announce(title + ' added to your cart. Quantity ' + qty + '.'); }
    }).catch(function (err) {
      if (btn) btn.classList.remove('is-loading');
      toast(err.message, true);
    });
  });

  /* Quantity changes: optimistic update, debounced 280 ms, keyed by line item key so lines never shift (Baymard auto-update). */
  var qTimers = {};
  var queue = Promise.resolve();
  function setCartBusy(on) {
    var a = $('[data-lav-cart-drawer]'), b = $('[data-lav-cart-section]');
    if (a) a.classList.toggle('is-busy', on);
    if (b) b.classList.toggle('is-busy', on);
  }
  function sendChange(key, qty) {
    queue = queue.then(function () {
      setCartBusy(true);
      return Cart.change(key, qty).then(function (res) {
        Cart.apply(res.sections);
        updateCount(res.item_count);
        announce(qty === 0 ? 'Item removed. Cart has ' + res.item_count + ' items.' : 'Cart updated. ' + res.item_count + ' items.');
      }).catch(function (err) {
        toast(err.message, true);
        return Cart.refresh();
      }).then(function () { setCartBusy(false); });
    });
  }
  function scheduleChange(key, qty) {
    clearTimeout(qTimers[key]);
    if (qty === 0) { delete qTimers[key]; sendChange(key, 0); return; }
    qTimers[key] = setTimeout(function () { delete qTimers[key]; sendChange(key, qty); }, 280);
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lav-line]');
    if (!b || b.matches('input')) return;
    e.preventDefault();
    var key = b.getAttribute('data-lav-line');
    var step = b.getAttribute('data-lav-step');
    if (step === null) {
      var row = b.closest('[data-lav-row]');
      if (row && !reduceMotion.matches) row.classList.add('is-leaving');
      scheduleChange(key, parseInt(b.getAttribute('data-qty'), 10) || 0);
      return;
    }
    var holder = b.closest('.lav-qty');
    var val = holder && (holder.querySelector('.lav-qty__val') || holder.querySelector('[data-lav-line-input]'));
    var cur = val ? parseInt(val.value !== undefined && val.tagName === 'INPUT' ? val.value : val.textContent, 10) || 0 : 0;
    var next = Math.max(0, cur + parseInt(step, 10));
    if (val) { if (val.tagName === 'INPUT') val.value = next; else val.textContent = next; }
    if (next === 0) { var r2 = b.closest('[data-lav-row]'); if (r2 && !reduceMotion.matches) r2.classList.add('is-leaving'); }
    scheduleChange(key, next);
  });
  d.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('[data-lav-line-input]');
    if (!i) return;
    scheduleChange(i.getAttribute('data-lav-line-input'), Math.max(0, parseInt(i.value, 10) || 0));
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-lav-line-input]')) { e.preventDefault(); e.target.blur(); }
  });

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-lav-skuadd]')) return;
    e.preventDefault();
    var raw = (f.elements.sku.value || '').trim();
    var code = raw.toLowerCase();
    var qty = Math.max(1, parseInt(f.elements.qty.value, 10) || 1);
    var opt = $$('#LavSkuList option').filter(function (o) { return o.value.toLowerCase() === code; })[0];
    if (!opt) { toast('No product found with code “' + raw + '”. Check the code or use search.', true); return; }
    var btn = $('[type="submit"]', f);
    if (btn) btn.classList.add('is-loading');
    Cart.addItems([{ id: parseInt(opt.getAttribute('data-id'), 10), quantity: qty }]).then(function (res) {
      Cart.apply(res.sections);
      toast('Added ' + qty + ' × ' + opt.textContent);
    }).catch(function (err) { toast(err.message, true); }).then(function () {
      var b2 = $('[data-lav-skuadd] [type="submit"]');
      if (b2) b2.classList.remove('is-loading');
      var f2 = $('[data-lav-skuadd]');
      if (f2 && f2.elements.sku) f2.elements.sku.focus();
    });
  });

  var noteTimer;
  d.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-lav-cart-note]')) return;
    var status = t.parentElement.querySelector('[data-lav-note-status]');
    if (status) status.textContent = 'Saving…';
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      Cart.update({ note: t.value }).then(function () { if (status) status.textContent = 'Saved'; }).catch(function () { if (status) status.textContent = 'Not saved. Please try again.'; });
    }, 600);
  });

  /* ---------- Predictive search (products, categories, pages; exact product code first) ---------- */
  var search = d.getElementById('LavSearch');
  if (search) {
    var sInput = $('[data-lav-search-input]', search);
    var sLive = $('[data-lav-search-live]', search);
    var sDefault = $('[data-lav-search-default]', search);
    var sTimer, sCtrl, sIdx = -1, sCache = {};
    var renderSuggest = function (h, q) {
      sLive.innerHTML = h;
      sDefault.hidden = !!h;
      sIdx = -1;
      sInput.setAttribute('aria-expanded', h ? 'true' : 'false');
      sInput.removeAttribute('aria-activedescendant');
      var ps = $('.lav-ps', sLive);
      if (ps && q) {
        var exact = $('.lav-ps__item[data-sku="' + q.toLowerCase().replace(/"/g, '') + '"]', ps);
        if (exact) { var li = exact.closest('li'); if (li && li.parentElement.firstElementChild !== li) li.parentElement.insertBefore(li, li.parentElement.firstElementChild); exact.classList.add('is-exact'); }
        var count = parseInt(ps.getAttribute('data-count'), 10) || 0;
        announce(count ? count + ' suggestions available' : 'No suggestions');
      }
      if (ps && !reduceMotion.matches) ps.classList.add('is-entering');
    };
    var fetchSuggest = function (q) {
      if (sCache[q] !== undefined) { renderSuggest(sCache[q], q); return; }
      if (sCtrl && sCtrl.abort) sCtrl.abort();
      sCtrl = window.AbortController ? new AbortController() : null;
      search.classList.add('is-busy');
      var url = ROOT + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag' +
        '&section_id=lav-predictive-search';
      fetch(url, sCtrl ? { signal: sCtrl.signal } : {}).then(function (r) { return r.text(); }).then(function (t) {
        var root = parseHTML(t).querySelector('[data-lav-ps-root]');
        var h = root ? root.outerHTML : '';
        sCache[q] = h;
        if (sInput.value.trim() === q) renderSuggest(h, q);
      }).catch(function () {}).then(function () { search.classList.remove('is-busy'); });
    };
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { renderSuggest('', ''); return; }
      sTimer = setTimeout(function () { fetchSuggest(q); }, 180);
    });
    sInput.addEventListener('keydown', function (e) {
      var opts = $$('[role="option"], #lav-ps-all', sLive);
      if (!opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        sIdx = (sIdx + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === sIdx ? 'true' : 'false'); });
        if (opts[sIdx].id) sInput.setAttribute('aria-activedescendant', opts[sIdx].id);
        opts[sIdx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && sIdx > -1) {
        e.preventDefault();
        opts[sIdx].click();
      }
    });
    search.addEventListener('lav:open', function () { if (sInput.value.trim().length >= 2) fetchSuggest(sInput.value.trim()); });
  }

  /* ---------- Reveal on scroll (content already in view is never hidden) ---------- */
  var reveals = $$('[data-lav-reveal]');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var vh = window.innerHeight || d.documentElement.clientHeight;
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      reveals.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) el.classList.add('is-in'); else ro.observe(el);
      });
    }
  }

  /* ---------- Product gallery and lightbox with zoom ---------- */
  var lbZoomed = null;
  function unzoom() {
    if (!lbZoomed) return;
    lbZoomed.classList.remove('is-zoomed');
    var lb = lbZoomed.closest('.lav-lightbox');
    if (lb) lb.classList.remove('is-zoomed');
    lbZoomed = null;
  }
  $$('[data-lav-gallery]').forEach(function (g) {
    var track = $('[data-gal-track]', g);
    var slides = $$('[data-gal-slide]', g);
    var thumbs = $$('[data-gal-thumb]', g);
    var dots = $$('[data-gal-dot]', g);
    var counter = $('[data-gal-count]', g);
    if (!track || slides.length < 1) return;
    var current = 0;
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (thumbs[i] && thumbs[i].parentElement.scrollWidth > thumbs[i].parentElement.clientWidth) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: behaviour() });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behaviour() });
      mark(i);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio > 0.6) mark(slides.indexOf(en.target)); });
      }, { root: track, threshold: [0.61] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-gal-prev]', g), next = $('[data-gal-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'Enter' && slides[current] && slides[current].hasAttribute('data-gal-zoom')) { e.preventDefault(); slides[current].click(); }
    });
    var tpl = $('template[data-lav-lightbox-tpl]', g);
    if (!tpl) return;
    var lb = d.createElement('div');
    lb.className = 'lav lav-lightbox';
    lb.id = 'LavLightbox';
    lb.setAttribute('data-lav-layer', '');
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.hidden = true;
    lb.appendChild(tpl.content.cloneNode(true));
    d.body.appendChild(lb);
    var lbTrack = $('[data-lb-track]', lb);
    var lbSlides = $$('[data-lb-slide]', lb);
    var lbCount = $('[data-lb-count]', lb);
    var lbIdx = 0;
    var lbGo = function (i, smooth) {
      unzoom();
      lbIdx = Math.max(0, Math.min(lbSlides.length - 1, i));
      lbTrack.scrollTo({ left: lbSlides[lbIdx].offsetLeft, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
      if (lbCount) lbCount.textContent = (lbIdx + 1) + ' / ' + lbSlides.length;
    };
    lbTrack.addEventListener('scroll', function () {
      var i = Math.round(lbTrack.scrollLeft / Math.max(1, lbTrack.clientWidth));
      if (i !== lbIdx) { lbIdx = i; if (lbCount) lbCount.textContent = (lbIdx + 1) + ' / ' + lbSlides.length; }
    }, { passive: true });
    var lbPrev = $('[data-lb-prev]', lb), lbNext = $('[data-lb-next]', lb);
    if (lbPrev) lbPrev.addEventListener('click', function () { lbGo(lbIdx - 1, true); });
    if (lbNext) lbNext.addEventListener('click', function () { lbGo(lbIdx + 1, true); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbIdx + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbIdx - 1, true); }
    });
    var setOrigin = function (slide, x, y) {
      var img = $('img', slide);
      if (!img) return;
      var r = img.getBoundingClientRect();
      var px = Math.max(0, Math.min(100, (x - r.left) / r.width * 100));
      var py = Math.max(0, Math.min(100, (y - r.top) / r.height * 100));
      img.style.transformOrigin = px + '% ' + py + '%';
    };
    var lastTap = 0;
    lbSlides.forEach(function (slide) {
      var img = $('img', slide);
      if (!img) return;
      var toggle = function (x, y) {
        if (lbZoomed === slide) { unzoom(); return; }
        unzoom();
        setOrigin(slide, x, y);
        slide.classList.add('is-zoomed');
        lb.classList.add('is-zoomed');
        lbZoomed = slide;
      };
      img.addEventListener('click', function (e) { if (hoverMq.matches) toggle(e.clientX, e.clientY); });
      img.addEventListener('mousemove', function (e) { if (lbZoomed === slide) setOrigin(slide, e.clientX, e.clientY); });
      img.addEventListener('touchend', function (e) {
        var now = Date.now();
        if (now - lastTap < 300 && e.changedTouches[0]) { e.preventDefault(); toggle(e.changedTouches[0].clientX, e.changedTouches[0].clientY); }
        lastTap = now;
      });
      img.addEventListener('touchmove', function (e) { if (lbZoomed === slide && e.touches[0]) { e.preventDefault(); setOrigin(slide, e.touches[0].clientX, e.touches[0].clientY); } }, { passive: false });
    });
    lb.addEventListener('lav:close', unzoom);
    slides.forEach(function (s, k) {
      if (!s.hasAttribute('data-gal-zoom')) return;
      s.addEventListener('click', function () {
        openLayer('LavLightbox', s);
        requestAnimationFrame(function () { lbGo(k, false); });
      });
    });
  });

  /* ---------- Product page buy box: live totals, volume tiers, delivery gap, cart sync, sticky bar ---------- */
  var buyForm = $('[data-lav-buy-form]');
  if (buyForm) {
    var mainQty = $('[data-lav-qty-main]', buyForm);
    var base = parseInt(buyForm.getAttribute('data-price'), 10) || 0;
    var pid = buyForm.getAttribute('data-pid');
    var cartTotal = parseInt(buyForm.getAttribute('data-cart-total'), 10) || 0;
    var breaks = [];
    try { breaks = JSON.parse(buyForm.getAttribute('data-breaks') || '[]') || []; } catch (e) { breaks = []; }
    breaks.sort(function (a, b) { return a.q - b.q; });
    var volRows = $$('.lav-vol__table tbody tr', buyForm);
    var calc = $('[data-lav-calc]', buyForm);
    var ship = $('[data-lav-ship]', buyForm);
    var shipMsg = ship && $('[data-lav-ship-msg]', ship);
    var shipFill = ship && $('[data-lav-ship-fill]', ship);
    var freeFrom = ship ? (parseInt(ship.getAttribute('data-free'), 10) || 0) : 0;
    var incart = $('[data-lav-incart]');
    var incartN = incart && $('[data-lav-incart-n]', incart);
    var promoBox = $('[data-lav-promo]');
    var satc = $('[data-lav-satc]');
    var satcQty = satc && $('[data-lav-qty-sticky]', satc);
    var minQ = mainQty ? (parseInt(mainQty.min, 10) || 1) : 1;
    var unitFor = function (q) {
      var u = base, tier = 0;
      breaks.forEach(function (b, i) { if (q >= b.q) { u = b.p; tier = i + 1; } });
      return { unit: u, tier: tier };
    };
    var refresh = function () {
      var q = Math.max(minQ, parseInt(mainQty.value, 10) || minQ);
      var t = unitFor(q);
      var line = t.unit * q;
      if (calc) calc.innerHTML = q + ' × ' + money(t.unit) + ' = <strong>' + money(line) + '</strong> ex VAT · ' + money(line * 1.2) + ' inc VAT';
      volRows.forEach(function (r, i) { r.classList.toggle('is-active', i === t.tier); });
      if (ship && freeFrom > 0) {
        var inc = (cartTotal + line) * 1.2;
        var left = freeFrom - inc;
        ship.classList.toggle('lav-meter--ok', left <= 0);
        if (shipMsg) shipMsg.textContent = left <= 0 ? (cartTotal > 0 ? 'Together with your cart, this qualifies for free UK delivery' : 'Qualifies for free UK delivery') : 'Add ' + money(left) + ' more (inc VAT) for free UK delivery';
        if (shipFill) shipFill.style.width = Math.min(100, inc * 100 / freeFrom) + '%';
      }
      if (satcQty && satcQty.value !== String(q)) satcQty.value = q;
    };
    var syncCart = function (root) {
      if (!root) return;
      cartTotal = parseInt(root.getAttribute('data-total'), 10) || 0;
      var n = cartLines(root)[pid] || 0;
      if (incart) { incart.hidden = n === 0; if (incartN) incartN.textContent = n; }
      if (promoBox) {
        var target = parseInt(promoBox.getAttribute('data-target'), 10) || 5;
        var fill = $('[data-lav-promo-fill]', promoBox), msg = $('[data-lav-promo-msg]', promoBox);
        if (fill) fill.style.width = Math.min(100, n / target * 100) + '%';
        if (msg) msg.textContent = n >= target ? 'Promotion reached. We add your EXOPEN when we confirm the order.' : n + ' of ' + target + ' boxes in your cart · add ' + (target - n) + ' more';
      }
      refresh();
    };
    if (mainQty) {
      mainQty.addEventListener('input', refresh);
      mainQty.addEventListener('blur', function () { var v = parseInt(mainQty.value, 10); if (!v || v < minQ) { mainQty.value = minQ; refresh(); } });
      refresh();
      d.addEventListener('lav:cart', function (e) { syncCart(e.detail && e.detail.root); });
    }
    if (satcQty && mainQty) {
      satcQty.addEventListener('input', function () { mainQty.value = Math.max(minQ, parseInt(satcQty.value, 10) || minQ); refresh(); });
    }
    var anchor = $('[data-lav-buy-anchor]');
    if (satc && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        satc.classList.toggle('is-open', past);
        satc.setAttribute('aria-hidden', past ? 'false' : 'true');
        $$('a, button, input', satc).forEach(function (n) { n.tabIndex = past ? 0 : -1; });
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ---------- Listing: grid or list view, compare (max 3), AJAX filters, sort and pagination ---------- */
  var store = {
    get: function (k, def) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : def; } catch (e) { return def; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function savedView() { try { return localStorage.getItem('lavView') || 'grid'; } catch (e) { return 'grid'; } }
  function setView(v, save) {
    var wrap = $('[data-lav-viewwrap]');
    if (wrap) wrap.classList.toggle('is-list', v === 'list');
    $$('[data-lav-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lav-view') === v ? 'true' : 'false'); });
    if (save) { try { localStorage.setItem('lavView', v); } catch (e) {} }
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lav-view]');
    if (!b) return;
    var v = b.getAttribute('data-lav-view');
    if (d.startViewTransition && !reduceMotion.matches) d.startViewTransition(function () { setView(v, true); }); else setView(v, true);
    announce(v === 'list' ? 'List view' : 'Grid view');
  });

  var cmpMax = 3;
  var cmpSel = store.get('lavCmp', []);
  var cmpBar = null;
  function cmpSync() {
    $$('[data-lav-cmp]').forEach(function (c) { c.checked = cmpSel.some(function (x) { return x.h === c.value; }); });
    if (!cmpBar) {
      cmpBar = d.createElement('div');
      cmpBar.className = 'lav lav-cmpbar';
      cmpBar.setAttribute('role', 'region');
      cmpBar.setAttribute('aria-label', 'Compare products');
      d.body.appendChild(cmpBar);
    }
    if (!cmpSel.length || !$('[data-lav-cmp]')) { cmpBar.classList.remove('is-open'); return; }
    cmpBar.innerHTML = '<div class="lav-cmpbar__items">' + cmpSel.map(function (x) {
      return '<span class="lav-chip lav-chip--on">' + esc(x.t) + '<button type="button" data-lav-cmp-rm="' + esc(x.h) + '" aria-label="Remove ' + esc(x.t) + ' from comparison">×</button></span>';
    }).join('') + '</div><div class="lav-cmpbar__actions"><button type="button" class="lav-link" data-lav-cmp-clear>Clear</button><button type="button" class="lav-btn lav-btn--primary" data-lav-cmp-go' + (cmpSel.length < 2 ? ' disabled' : '') + '>Compare (' + cmpSel.length + ')</button></div>';
    requestAnimationFrame(function () { cmpBar.classList.add('is-open'); });
  }
  d.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-lav-cmp]');
    if (!c) return;
    if (c.checked) {
      if (cmpSel.length >= cmpMax) { c.checked = false; toast('You can compare up to ' + cmpMax + ' products at a time.', true); return; }
      cmpSel.push({ h: c.value, t: c.getAttribute('data-title') || c.value });
    } else {
      cmpSel = cmpSel.filter(function (x) { return x.h !== c.value; });
    }
    store.set('lavCmp', cmpSel);
    cmpSync();
    announce(cmpSel.length + ' of ' + cmpMax + ' products selected for comparison');
  });
  d.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-lav-cmp-rm]');
    if (rm) { cmpSel = cmpSel.filter(function (x) { return x.h !== rm.getAttribute('data-lav-cmp-rm'); }); store.set('lavCmp', cmpSel); cmpSync(); return; }
    if (e.target.closest('[data-lav-cmp-clear]')) { cmpSel = []; store.set('lavCmp', cmpSel); cmpSync(); return; }
    var go = e.target.closest('[data-lav-cmp-go]');
    if (go) openCompare(go);
  });
  function specOf(htmlStr) {
    var out = {}, order = [];
    $$('li', parseHTML(htmlStr || '')).forEach(function (li) {
      var t = li.textContent.trim(), i = t.indexOf(': ');
      if (i > 0) { var k = t.slice(0, i); out[k] = t.slice(i + 2); order.push(k); }
    });
    return { map: out, order: order };
  }
  function openCompare(btn) {
    var dlg = d.getElementById('LavCompare');
    if (!dlg) {
      dlg = d.createElement('div');
      dlg.className = 'lav lav-modal';
      dlg.id = 'LavCompare';
      dlg.setAttribute('data-lav-layer', '');
      dlg.setAttribute('role', 'dialog');
      dlg.setAttribute('aria-modal', 'true');
      dlg.setAttribute('aria-labelledby', 'LavCompareTitle');
      dlg.hidden = true;
      d.body.appendChild(dlg);
    }
    dlg.innerHTML = '<div class="lav-modal__head"><p class="lav-h3" id="LavCompareTitle">Compare products</p><button type="button" class="lav-iconbtn" data-lav-close aria-label="Close comparison">×</button></div><div class="lav-modal__body"><p class="lav-small lav-muted">Loading…</p></div>';
    openLayer('LavCompare', btn);
    Promise.all(cmpSel.map(function (x) {
      return fetch(ROOT + 'products/' + encodeURIComponent(x.h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      var specs = list.map(function (p) { return specOf(p.description); });
      var keys = [];
      specs.forEach(function (s) { s.order.forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
      var col = function (fn) { return list.map(function (p, i) { return '<td>' + fn(p, i) + '</td>'; }).join(''); };
      var rows = [];
      rows.push('<tr class="lav-cmp__prod"><th scope="row"><span class="lav-visually-hidden">Product</span></th>' + col(function (p) {
        var img = p.featured_image ? '<img src="' + esc(p.featured_image) + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=320" alt="" loading="lazy">' : '';
        return '<a class="lav-cmp__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a><a class="lav-cmp__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="lav-caption lav-muted">' + esc(p.vendor) + ' · ' + esc(p.type) + '</span>';
      }) + '</tr>');
      rows.push('<tr><th scope="row">Trade price</th>' + col(function (p) { return p.price > 0 ? '<strong>' + money(p.price) + '</strong> ex VAT<br><span class="lav-caption lav-muted">' + money(p.price * 1.2) + ' inc VAT</span>' : 'Price on request'; }) + '</tr>');
      rows.push('<tr><th scope="row">Product code</th>' + col(function (p) { return esc((p.variants[0] && p.variants[0].sku) || '·'); }) + '</tr>');
      rows.push('<tr><th scope="row">Availability</th>' + col(function (p) { return p.available ? 'In stock' : 'Out of stock'; }) + '</tr>');
      keys.forEach(function (k) {
        var vals = specs.map(function (s) { return s.map[k] || '·'; });
        var same = vals.every(function (v) { return v === vals[0]; });
        rows.push('<tr' + (same ? '' : ' class="is-diff"') + '><th scope="row">' + esc(k) + '</th>' + vals.map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>');
      });
      var body = $('.lav-modal__body', dlg);
      body.innerHTML = list.length < 2 ? '<p class="lav-small lav-muted">These products could not be loaded. Please try again.</p>' :
        '<label class="lav-cmp__toggle"><input type="checkbox" data-lav-cmp-diff> Highlight differences only</label><div class="lav-cmp__scroll"><table class="lav-cmp"><caption class="lav-visually-hidden">Product comparison</caption>' + rows.join('') + '</table></div>';
      var diff = $('[data-lav-cmp-diff]', body);
      if (diff) diff.addEventListener('change', function () { $('.lav-cmp', body).classList.toggle('is-diffonly', diff.checked); });
    });
  }

  function initPlp() { setView(savedView(), false); cmpSync(); if (cartBox) flagCards($('[data-lav-cart-root]', cartBox)); }
  var plp = $('[data-lav-plp]');
  if (plp) {
    var loadPlp = function (url, push) {
      var section = plp.getAttribute('data-section');
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', section);
      plp.setAttribute('aria-busy', 'true');
      fetch(u.toString(), { headers: { Accept: 'text/html' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
        var fresh = parseHTML(t).querySelector('[data-lav-plp]');
        if (!fresh) throw new Error('no section');
        if (active) closeLayer(true, true);
        var swap = function () {
          var oldSheet = d.getElementById('LavFilters');
          if (oldSheet && !plp.contains(oldSheet)) oldSheet.remove();
          plp.replaceWith(fresh);
          plp = fresh;
          $$('[data-lav-portal]', plp).forEach(function (el) { d.body.appendChild(el); });
          initPlp();
        };
        if (d.startViewTransition && !reduceMotion.matches) d.startViewTransition(swap); else swap();
        if (push) history.pushState({ lavPlp: true }, '', url);
        var count = $('.lav-plp__count', plp) || $('.lav-plp__head .lav-m-only', plp);
        if (count) announce(count.textContent.trim());
        if (plp.getBoundingClientRect().top < 0) plp.scrollIntoView({ behavior: behaviour(), block: 'start' });
      }).catch(function () { location.href = url; });
    };
    d.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-lav-plp-link]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      loadPlp(a.href, true);
    });
    d.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('select[data-lav-sort]');
      if (!s) return;
      var u = new URL(location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      loadPlp(u.toString(), true);
    });
    window.addEventListener('popstate', function () { if ($('[data-lav-plp]')) loadPlp(location.href, false); });
    initPlp();
  }

  /* ---------- Dispatch cut-off countdown and delivery estimate ----------
     Config comes from theme settings (header outputs #LavDelivery). All dates are
     worked out in Europe/London time, skipping weekends and the listed non-dispatch days.
     Text updates at most every 30 s while the tab is visible and is never announced live. */
  (function () {
    var cfgEl = d.getElementById('LavDelivery');
    if (!cfgEl || !window.Intl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var cut = parseInt(cfg.cutoff, 10) || 15;
    var sat = !!cfg.saturday;
    var transit = Math.max(1, parseInt(cfg.transit, 10) || 1);
    var hol = {};
    (cfg.holidays || []).forEach(function (h) { hol[String(h).trim()] = 1; });
    var parts;
    try { parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); } catch (e) { return; }
    var dayName = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long' });
    var longDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    function london() {
      var o = {};
      parts.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, min: +o.minute };
    }
    function civil(y, m, dd) { return new Date(Date.UTC(y, m - 1, dd)); }
    function add(dt, n) { return new Date(dt.getTime() + n * 864e5); }
    function iso(dt) { return dt.toISOString().slice(0, 10); }
    function canDispatch(dt) { var w = dt.getUTCDay(); return w !== 0 && (w !== 6 || sat) && !hol[iso(dt)]; }
    function canDeliver(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && !hol[iso(dt)]; }
    function plan() {
      var n = london();
      var today = civil(n.y, n.m, n.d);
      var mins = cut * 60 - (n.h * 60 + n.min);
      var go = today, left = 0, guard = 0;
      if (canDispatch(today) && mins > 0) left = mins;
      else { go = add(today, 1); while (!canDispatch(go) && guard++ < 40) go = add(go, 1); }
      var del = go, t = 0;
      guard = 0;
      while (t < transit && guard++ < 40) { del = add(del, 1); if (canDeliver(del)) t++; }
      return { today: today, go: go, left: left, del: del };
    }
    function span(m) {
      var h = Math.floor(m / 60), mm = m % 60, out = [];
      if (h) out.push(h + (h === 1 ? ' hr' : ' hrs'));
      if (mm || !h) out.push(mm + (mm === 1 ? ' min' : ' mins'));
      return out.join(' ');
    }
    function whenGo(p) {
      var diff = Math.round((p.go - p.today) / 864e5);
      if (diff === 1) return 'tomorrow';
      if (diff < 7) return 'on ' + dayName.format(p.go);
      return 'on ' + longDate.format(p.go);
    }
    function render() {
      var p = plan();
      var lead = p.left > 0
        ? 'Order within <strong>' + span(p.left) + '</strong> for same-day dispatch'
        : 'Order now for dispatch <strong>' + whenGo(p) + '</strong>';
      var est = 'Estimated delivery <strong>' + longDate.format(p.del) + '</strong>' + (cfg.courier ? ' by ' + esc(cfg.courier) : '');
      $$('[data-lav-dispatch]').forEach(function (el) {
        var l = $('[data-lav-dispatch-lead]', el), s = $('[data-lav-dispatch-est]', el);
        if (l && l.innerHTML !== lead) l.innerHTML = lead;
        if (s && s.innerHTML !== est) s.innerHTML = est;
        el.classList.add('is-ready');
        el.classList.toggle('is-live', p.left > 0);
      });
    }
    window.LavDispatch = { render: render, plan: plan };
    render();
    setInterval(function () { if (!d.hidden) render(); }, 30000);
    d.addEventListener('visibilitychange', function () { if (!d.hidden) render(); });
  })();

  /* Enhanced styles (reveal, section nav) switch on only once this script is running. */
  html.classList.add('lav-ready');
})();
